import { EntityWidget } from "./EntityWidget";
import { ArrangementObjectEntityController } from "../ArrangementEntityController";
import { ArrangementObject } from "@rhinov/savane-js";
import { _ASSET_TYPE, getAsset, getResourcesPinboards, getToken } from "@rhinov/asset-manager-service";



export class ArrangementObjectEntityWidget extends EntityWidget {

    declare controller: ArrangementObjectEntityController;
    declare entity: ArrangementObject;

    pinboardSetter = () => {
        this.controller.addOrRemoveFromPinboards();
    }

    copyId = () => {
        this.controller.copyAssetID();
    }

    reportAssetArrangementIssue = () => {
        this.controller.openAssetIssue();
    }

    handletripleToggle = (event: Event) => {
        this.controller.setToggleHandleValue((event.currentTarget as HTMLButtonElement & { param?: any }).param);
    }

    handleAssetEvent = (event: MouseEvent) => {
        if (event.ctrlKey || (event.currentTarget as HTMLButtonElement & { param?: any }).id === 'openAssetArrangement') {
            this.controller.openAssetDetail((event.currentTarget as HTMLButtonElement & { param?: any }).param);
            return;
        }
        if (!event.ctrlKey && event.button === 0) {
            this.controller.updateArrangementObjectType((event.currentTarget as HTMLButtonElement & { param?: any }).param);
        }
    }

    openObjectShop = (event: Event) => {
        this.controller.openUrl((event.currentTarget as HTMLButtonElement & { param?: any }).param);
        event.stopPropagation();
    }

    constructor(entity: ArrangementObject, panel: any, deliverable: any, designer: any, openAssetDetailCallback: CallableFunction) {
        super(entity, panel, deliverable, openAssetDetailCallback);
        this.controller = new ArrangementObjectEntityController(entity, panel, deliverable, designer, openAssetDetailCallback);
        if (this.entity.stretchability) {
            this.propertiesTab = ['plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'dropDown', 'buttonToggle',
                'buttonToggle', 'buttonToggleLight', 'buttonToggleLight', 'dropDown', 'colorSelector', 'tripleToggleHandle', 'previewArrangement', 'selectArrangementobjectModel'];
        } else {
            this.propertiesTab =  ['staticCm', 'staticCm', 'staticCm', 'plusLess', 'buttonToggle', 'dropDown', 'buttonToggle', 'buttonToggleLight', 'buttonToggleLight', 'dropDown', 'colorSelector',
                'tripleToggleHandle', 'selectCustomizationCoating', 'selectPlinthCoating', 'selectArrangementHandleModel', 'previewArrangement', 'selectArrangementobjectModel']
        }
        this.controller.propertiesTab = this.propertiesTab;
        this.callAssetManager()
    }

    callAssetManager() {
        getAsset(_ASSET_TYPE.ARRANGEMENTS, this.entity.objectId, getToken(), (res: any) => {
            this.controller.arrangement = res;
            this.controller.dropDownDatas.wallCoveringList = [];
            if (res.configs !== undefined) {
                for (var i = 0; i < res.configs.length; i++) {
                    this.controller.dropDownDatas.wallCoveringList.push({
                        name: res.configs[i].name,
                        value: (i + 1) + ''
                    });
                }
            }

            if (this.controller.designer && this.controller.arrangement) {
                getResourcesPinboards(this.controller.arrangement._id, this.controller.designer.mail, (data: any) => {
                    if (data && data.resources && this.controller.arrangement) {
                        for (var i = 0; i < data.resources.length; i++) {
                            var pinboard = data.resources[i];
                            for (var j = 0; j < pinboard.items.length; ++j) {
                                if (this.controller.arrangement._id === pinboard.items[j]) {
                                    this.controller.arrangement.pinboard = true;
                                }
                            }
                        }
                    }
                    this.updateColorIdDropDown();
                });
            } else {
                this.updateColorIdDropDown();
            }
        });
    }

    updateColorIdDropDown(){
        let colorid = document.getElementById('property_colorId') as HTMLInputElement;
        var property = this.panel.properties.find((obj: any) => obj.key === '_colorId');
        if (colorid) {
            colorid.innerHTML = this.handleDropDownOptions(property);
            requestAnimationFrame(() => {
                colorid.value = this.controller.model._colorId;
            });
    }
    }

    tripleToggleHandle(property: any): string {
        if (this.controller.arrangementCanHaveOrientedHandles()) {
            return `
                <!-- Triple state toggle for handle positions-->
                <div class="property-item handle_position padding">
                    <div class="form triple-toggle">
                        <div class="triple-toggle-radios">
                            <input type="radio" name="event_handle_left" class="left" id="radio-right1_handle_left"/>
                            <label for="radio-right1_handle_left"></label>
                            <input type="radio" name="event_handle_center" class="middle" checked
                                id="radio-middle1_handle_center"/>
                            <label for="radio-middle1_handle_center"></label>
                            <input type="radio" name="event_handle_right" class="right" id="radio-left1_handle_right"/>
                            <label for="radio-left1_handle_right"></label>
                        </div>
                        <label>${property.text}</label>
                    </div>
                </div>
            `;
        }
        return "";
    }

    settripleToggleHandleListener() {
        let left = document.getElementById('radio-right1_handle_left') as HTMLButtonElement & { param?: number};
        if (left) {
            left.param = -1;
            left.addEventListener('click', this.handletripleToggle);
        }
        let middle = document.getElementById('radio-middle1_handle_center') as HTMLButtonElement & { param?: number};;
        if (middle) {
            middle.param = 0;
            middle.addEventListener('click', this.handletripleToggle);
        }
        let right = document.getElementById('radio-left1_handle_right') as HTMLButtonElement & { param?: number};;
        if (right) {
            right.param = 1;
            right.addEventListener('click', this.handletripleToggle);
        }
    }

    removetripleToggleHandleListener() {
        let left = document.getElementById('radio-right1_handle_left');
        if (left) {
            left.removeEventListener('click', this.handletripleToggle);
        }
        let middle = document.getElementById('radio-middle1_handle_center');
        if (middle) {
            middle.removeEventListener('click', this.handletripleToggle);
        }
        let right = document.getElementById('radio-left1_handle_right');
        if (right) {
            right.removeEventListener('click', this.handletripleToggle);
        }
    }

    handleShoppingcart(currentResource: any, index: number): string {
        if (currentResource.marketLink && currentResource.manufacturer!=undefined) {
            return `
                <div id="openObjectShop-${index}" style="position:absolute;bottom:0;right:0;height:12px;cursor:pointer;font-size:12px;background-color:rgb(255, 255, 255);color:rgb(211, 211, 211)">
                    <i class="fa-solid fa-cart-shopping"></i>
                </div>
            `;
        }
        return "";
    }

    handleObjectList(): string {
        var html = "";
        var index = 0;
        this.controller.closeModelsForCurrentArrangementObject.forEach((currentResource: any) => {
            html += `
                <div style="display:inline-block;width:120px;height:120px;position:relative;vertical-align:text-bottom">

                        ${currentResource.isNewProduct ? `
                            <div style="position:absolute;top:0;left:48px;height:12px;cursor:pointer;font-size:16px;color:rgb(0, 102, 255);" title="Nouveauté">
                                <i class="fa-solid fa-star"></i>
                            </div>
                            ` : ""}
                        
                        <!-- asset price displayed bottom left -->
                        <div style="position:absolute;bottom:2px;left:0;height:12px;cursor:pointer;font-size:12px;background-color:rgb(255, 255, 255);color:${this.controller.getTopFlop(currentResource)}" title="prix">
                            ${this.controller.generatePriceString(currentResource)}
                        </div>

                        <img id="arrangementObject-${index}" style="width:120px;height:120px;"
                            src="${this.controller.getArrangementObjectPreviewUrl(currentResource)}"
                            title="${currentResource.name + "-" + this.controller.generateDimensionsString(currentResource)}">

                        ${this.handleShoppingcart(currentResource, index)}
                    </div>
            `;
            index++;
        })
        return html;
    }

    setselectArrangementobjectModelListener() {
        var index = 0;
        this.controller.closeModelsForCurrentArrangementObject.forEach((currentResource: any) => {
            let element = document.getElementById(`arrangementObject-${index}`) as HTMLButtonElement & { param?: any};;
            if (element) {
                element.param = currentResource;
                element.addEventListener('mousedown', this.handleAssetEvent);
            }
            let shop = document.getElementById(`openObjectShop-${index}`) as HTMLButtonElement & { param?: any};;
            if (shop) {
                shop.param = currentResource.marketLink;
                shop.addEventListener('mousedown', this.openObjectShop);
            }
            index++;
        })

    }

    removeselectArrangementobjectModelListener() {
        var index = 0;
        this.controller.closeModelsForCurrentArrangementObject.forEach((currentResource: any) => {
            let element = document.getElementById(`arrangementObject-${index}`);
            if (element) {
                element.removeEventListener('mousedown', this.handleAssetEvent);
            }
            let shop = document.getElementById(`openObjectShop-${index}`);
            if (shop) {
                shop.removeEventListener('mousedown', this.openObjectShop);
            }
            index++;
        })

    }


    previewArrangement(property: any): string {
        return `
            <!-- PREVIEW -->
            <div id="previewArrangement" class="property-item padding tulipImage">
                ${property.title ? `
                    <h style="font-weight:600;">
                        ${property.title}
                    </h>` : ""}
                <div>
                    <img style="width:160px;height:160px;" src="${this.controller.itemPreview}" />
                </div>
            </div>
        `;
    }

    setpreviewArrangementListener() {
        let preview = document.getElementById('previewArrangement');
        if (preview) {
            preview.addEventListener('mousedown', this.previewDetails);
        } 
    }

    removepreviewArrangementListener() {
        let preview = document.getElementById('previewArrangement');
        if (preview) {
            preview.removeEventListener('mousedown', this.previewDetails);
        } 
    }

    selectArrangementobjectModel(property: any): string {
        return `
            <!--Select model for arrangement objects-->
            <div class="property-item padding tulipImage">
                ${property.title ? `
                    <h style="font-weight:600;">
                        ${property.title}
                    </h>` : ""}
                <div id="CloseObjectList" style="margin-bottom:10px;padding:0;width:382px;max-height:600px;overflow-y: auto">
                    ${this.handleObjectList()}
                </div>
            </div>
        `;
    }

   html(): string {
        var i;
        this.controller.loadCloseModelsForCurrentArrangementObject(() => {
            let element = document.getElementById('CloseObjectList');
            let name = document.getElementById('objectName');
            let dropdown = document.getElementById('property_colorId');
            if (element && name && dropdown) {
                element.innerHTML = this.handleObjectList();
                name.innerHTML = this.controller.arrangement.name ? this.controller.arrangement.name : (this.controller.arrangement.genericName ? this.controller.arrangement.genericName : this.controller.arrangement.marketName)
                setTimeout(() => {
                    this.setselectArrangementobjectModelListener();
                    var panel = document.getElementById('panelPropMovable');
                    panel!.style.width = 'auto';
                    void panel!.offsetWidth;
                    panel!.style.width = 'fit-content';
                }, 50);
            }
        });
        var html = this.nameHeader() + this.propertyStart();
        for (i = 0; i < this.propertiesTab.length; i++) {
            if ((this as any)[this.propertiesTab[i]] !== undefined) {
                html += (this as any)[this.propertiesTab[i]](this.panel.properties[i]);
            }
        }
        html += super.propertyEnd();
        return html;
    }

    setListener() {
        super.setListener();
        this.setnameHeaderListener();
    }

    removeListener() {
        super.removeListener();
        this.removenameHeaderListener();
    }

    setnameHeaderListener() {
        let pinboard = document.getElementById('addRemovePinboard');
        if (pinboard) {
            pinboard.addEventListener('click', this.pinboardSetter)
        }
        let idCopy = document.getElementById('copyId');
        if (idCopy) {
            idCopy.addEventListener('click', this.copyId)
        }
        let report = document.getElementById('reportAssetArrangementIssue');
        if (report) {
            report.addEventListener('click', this.reportAssetArrangementIssue)
        }
        let asset = document.getElementById('openAssetArrangement') as HTMLButtonElement & { param?: any };
        if (asset) {
            asset.param = this.controller.arrangement;
            asset.addEventListener('click', this.handleAssetEvent)
        }
    }

    removenameHeaderListener() {
        let pinboard = document.getElementById('addRemovePinboard');
        if (pinboard) {
            pinboard.removeEventListener('click', this.pinboardSetter)
        }
        let idCopy = document.getElementById('copyId');
        if (idCopy) {
            idCopy.removeEventListener('click', this.copyId)
        }
        let report = document.getElementById('reportAssetArrangementIssue');
        if (report) {
            report.removeEventListener('click', this.reportAssetArrangementIssue)
        }
        let asset = document.getElementById('openAssetArrangement');
        if (asset) {
            asset.removeEventListener('click', this.handleAssetEvent)
        }
    }

    nameHeader(): string{
        return `
            <!-- NAME ? -->
            <div id="propPanelName" style="padding-left:10px">
                <a id="openAssetArrangement" title="Ouvrir asset manager"
                    style="cursor: pointer;" class="icon-Link"></a>
                <a id="reportAssetArrangementIssue" title="Reporter un problème"
                    style="cursor: pointer;" class="icon-SMS"></a>
                <a id="copyId" title="Copier ID vers presse papier"
                    style="cursor: pointer;" class="icon-FloatBar_Lens"></a>
                <a id="addRemovePinboard" title="Favoris"
                    style="margin-right : 10px; cursor: pointer;"><i class="fa-regular fa-heart pinboard"></i></a>
                <a id="objectName"></a>
            </div>
            `;
    }
}